export const CREATE_SOURCE_NAME_REQUIRED_ERROR = "Name is required";
export const CREATE_SOURCE_UNEXPECTED_ERROR = "Unexpected error";
export const CREATE_SOURCE_PERMISSION_DENIED_HEADER = "Permission denied";
export const CREATE_SOURCE_PERMISSION_DENIED_SUBHEADER =
  "You don't have permission to create sources";
export const CREATE_SOURCE_FAILED_TO_CREATE_ERROR_HEADER = "Failed to create source";
